<script>
export let artist;
import blocksToHtml from '@sanity/block-content-to-html';
</script>

<article>
    <h1>{artist.name}</h1>
    {@html blocksToHtml({blocks: artist.biography})}
    <hr>
    {#each artist.images as image}
        <figure>
        <img src="{image.src}" alt="">
        <figcaption>{@html blocksToHtml({blocks: image.caption})}</figcaption>
        </figure>
        {/each}
</article>

<style>
h1 {
    color: var(--c-secondary);
    font-size: clamp(1rem, 6vw, 2.8rem);
}

figure {
    max-width: 100%;
    padding: 1rem;
}

figure img {
    max-width: 100%;
    max-height: 80vh;
}

figcaption :global(p){
    padding: 0.2rem 0;
    font-size: clamp(0.6rem, 4vw, 1rem);
    text-align: center;
}

article {
    padding: 5rem 0 2rem;
}
</style>